import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { LessonTeacher } from "../../Objects/OnlineLesson";

export interface TeacherRegdateProps {
    teacherData: LessonTeacher
}

const TeacherRegdate: React.FC<TeacherRegdateProps> = ({
    teacherData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{color: "#333399"}}>登録日</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{teacherData.create_at? format(new Date(teacherData.create_at), "yyyy年MM月dd日")  : "未登録"}</Typography>
            </Grid>
        </Grid>
    );
}

export default TeacherRegdate